// 選択肢の型定義
export interface Option {
  label: string;
  value: string | number;
  description?: string;
  disabled?: boolean | undefined;
}

export type Options = Option[];

/**
 * 体験を引数に取り、人数選択セレクトボックス用の配列を返却する
 * @returns {Options} - セレクトボックス用オプション
 */
export const buildWabunkaGuestsNumberOptions = (minGuestsPerReservation: number, maxGuests: number): Options => {
  const rangeArray: { label: string; value: number }[] = [];
  for (let index = minGuestsPerReservation; index <= maxGuests; index++) {
    rangeArray.push({ label: index.toString(), value: index });
  }
  return rangeArray;
};
